<template>
<div>
  <div v-if="hasPermission('AX_MERCHANT_MAINT')" class="text-end small text-info mb-2">
    <a @click.prevent="showForm()" href="#"><i class="fas fa-plus-square"></i> Add Account</a>
  </div>
  <table class="table small table-hover" v-if="mxAccounts.length > 0">
    <thead class="table-dark">
      <tr>
        <th>
          <a href="#" @click.prevent="sortList('accountId')" class="text-white text-decoration-none">Account ID
            <span v-if="sortBy === 'accountId'"><i class="fa-solid fa-arrow-down-short-wide ms-1 text-info"></i></span>
            <span v-else><i class="fa-solid fa-arrow-down-short-wide ms-1 text-secondary"></i></span>
          </a>
        </th>
        <th>
          <a href="#" @click.prevent="sortList('accountName')" class="text-white text-decoration-none">Account Name
            <span v-if="sortBy === 'accountName'"><i class="fa-solid fa-arrow-down-short-wide ms-1 text-info"></i></span>
            <span v-else><i class="fa-solid fa-arrow-down-short-wide ms-1 text-secondary"></i></span>
          </a>
        </th>
        <th>Website URL / Notes</th>
        <th>Daily Limit</th>
        <th>Monthly Limit</th>
        <th>Status</th>
        <th>&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="mxa in mxAccounts" :key="mxa.accountId">
        <td>{{mxa.accountId}}</td>
        <td>{{mxa.accountName}}</td>
        <td>
          <span>{{mxa.website ? mxa.website : '---'}}</span>
          <span v-if="mxa.notes" class="text-info small"><br/>{{mxa.notes}}</span>
        </td>
        <td>{{mxa.dailyLimit | number('0,0.00')}}</td>
        <td>{{mxa.monthlyLimit | number('0,0.00')}}</td>
        <td>{{mxa.active ? 'ACTIVE' : 'INACTIVE'}}</td>
        <td>
          <a href="#" @click.prevent="showForm(mxa)" v-b-tooltip.hover title="Edit Account"><i class="fas fa-edit pointer me-2 text-primary"></i></a>
          <a href="#" @click.prevent="showRules(mxa)" v-b-tooltip.hover title="Routing Rules"><i class="fa-solid fa-route text-primary"></i></a>
        </td>
      </tr>
    </tbody>
  </table>
  <div v-else class="text-center text-warning">No Merchant Accounts Found</div>
  
  <b-modal id="mxa-form" :title="'Account Details: ' + selectedAcct.accountName + ' (' + selectedAcct.accountId + ')'" hide-footer size="lg">
    <merchant-account-form :merchant-id="merchantId" :merchant-account="selectedAcct"
      @cancelled="$bvModal.hide('mxa-form')"
      @saved="refreshList">
    </merchant-account-form>
  </b-modal>
  
  <b-modal id="mxa-rules" :title="'Processor Routings: ' + selectedAcct.accountName + ' (' + selectedAcct.accountId + ')'" hide-footer size="xl">
    <merchant-proc-rules :mxa="selectedAcct">
    </merchant-proc-rules>
  </b-modal>
</div>
</template>

<script>
import HelpersMixin from '../utils/HelpersMixin.js'
import MerchantAccountForm from '../components/MerchantAccountForm.vue'
import MerchantProcRules from '../components/MerchantProcRules.vue'
export default {
  name: 'MerchantAccounts',
  mixins: [HelpersMixin],
  components: {
    MerchantAccountForm, MerchantProcRules
  },
  props: ['merchantId'],
  data () {
    return {
      mxAccounts: [],
      selectedAcct: {},
      sortBy: 'accountName'
    }
  },
  mounted () {
    this.getMerchantAccounts()
  },
  methods: {
    getMerchantAccounts: function () {
      this.axios.get('/ax/mxaccounts/' + this.merchantId)
        .then(response => {
          this.mxAccounts = response.data
          this.sortList()
        })
        .catch(error => {
          console.log(error.response.status)
        })
    },
    sortList: function (fld) {
      if (fld) {
        this.sortBy = fld
      }
      this.mxAccounts.sort((a,b) => {
        return a[this.sortBy].localeCompare(b[this.sortBy], undefined, {sensitivity: 'base'})
      })
    },
    showForm: function (mxa) {
      if (mxa) {
        this.selectedAcct = mxa
      } else {
        this.selectedAcct = {}
      }
      this.$bvModal.show('mxa-form')
    },
    showRules: function (mxa) {
      this.selectedAcct = mxa
      this.$bvModal.show('mxa-rules')
    },
    refreshList: function () {
      this.$bvModal.hide('mxa-form')
      this.getMerchantAccounts()
    }
  }
}
</script>
